import createIcon from '../../createIcon';

/**
 * @component @name CleaningServices
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgMTFIMTVWM0MxNSAxLjkgMTQuMSAxIDEzIDFIMTFDOS45IDEgOSAxLjkgOSAzVjExSDhDNS4yNCAxMSAzIDEzLjI0IDMgMTZWMjNIMjFWMTZDMjEgMTMuMjQgMTguNzYgMTEgMTYgMTFaTTE5IDIxSDE3VjE4QzE3IDE3LjQ1IDE2LjU1IDE3IDE2IDE3QzE1LjQ1IDE3IDE1IDE3LjQ1IDE1IDE4VjIxSDEzVjE4QzEzIDE3LjQ1IDEyLjU1IDE3IDEyIDE3QzExLjQ1IDE3IDExIDE3LjQ1IDExIDE4VjIxSDlWMThDOSAxNy40NSA4LjU1IDE3IDggMTdDNy40NSAxNyA3IDE3LjQ1IDcgMThWMjFINVYxNkM1IDE0LjM1IDYuMzUgMTMgOCAxM0gxNkMxNy42NSAxMyAxOSAxNC4zNSAxOSAxNlYyMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CleaningServices = createIcon('CleaningServices', [
  [
    'path',
    {
      d: 'M16 11H15V3C15 1.9 14.1 1 13 1H11C9.9 1 9 1.9 9 3V11H8C5.24 11 3 13.24 3 16V23H21V16C21 13.24 18.76 11 16 11ZM19 21H17V18C17 17.45 16.55 17 16 17C15.45 17 15 17.45 15 18V21H13V18C13 17.45 12.55 17 12 17C11.45 17 11 17.45 11 18V21H9V18C9 17.45 8.55 17 8 17C7.45 17 7 17.45 7 18V21H5V16C5 14.35 6.35 13 8 13H16C17.65 13 19 14.35 19 16V21Z',
      key: '1kaaj4',
    },
  ],
]);

export default CleaningServices;
